export default {"src":"/_next/static/media/dark-purple-to-light-purple-right.12290e9a.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};